<script>
import IconamoonDiscountLight from './IconamoonDiscountLight.vue';
import MaterialSymbolsLightPermMediaOutline from './MaterialSymbolsLightPermMediaOutline.vue';
import PhAddressBook from './PhAddressBook.vue';
import PhCalendar from './PhCalendar.vue';
import PhChatsCircle from './PhChatsCircle.vue';
import PhClipboardText from './PhClipboardText.vue';
import PhCube from './PhCube.vue';
import PhEnvelope from './PhEnvelope.vue';
import PhFolder from './PhFolder.vue';
import PhGear from './PhGear.vue';
import PhHouseLine from './PhHouseLine.vue';
import PhIdentificationCard from './PhIdentificationCard.vue';
import PhKanban from './PhKanban.vue';
import PhMagicWand from './PhMagicWand.vue';
import PhMoney from './PhMoney.vue';
import PhPaperPlaneTilt from './PhPaperPlaneTilt.vue';
import PhRobot from './PhRobot.vue';
import PhTag from './PhTag.vue';
import PhTextbox from './PhTextbox.vue';
import PhUsersFour from './PhUsersFour.vue';

export default {
  components: {
    PhMoney,
    PhUsersFour,
    PhKanban,
    PhIdentificationCard,
    PhCalendar,
    PhCube,
    PhRobot,
    PhHouseLine,
    PhFolder,
    PhAddressBook,
    MaterialSymbolsLightPermMediaOutline,
    PhPaperPlaneTilt,
    PhEnvelope,
    PhChatsCircle,
    PhMagicWand,
    PhTextbox,
    PhClipboardText,
    PhTag,
  },
  computed: {
    navigation() {
      const currentInstance = this;
      function hasPermission(permission) {
        return currentInstance.$membershipHasPermissionTo(permission);
      }
      function hasAllPermissions(permissions) {
        return permissions.every((permission) =>
          currentInstance.$membershipHasPermissionTo(permission)
        );
      }
      function isAdminOrSuperAdmin() {
        return currentInstance.$isAdminOrSuperAdmin;
      }

      const accountId = this.$currentAccount.id;

      const items = [
        {
          items: [
            {
              name: 'Διαθέσιμα αιτήματα',
              href: `/c/${accountId}/marketplace/listings`,
              icon: PhUsersFour,
              show: () => hasPermission('read contact request listings') || isAdminOrSuperAdmin(),
            },
          ],
        },
        {
          name: 'Ver 3 (New)',
          items: [
            {
              name: 'Οι επαφές μου',
              href: `/c/${accountId}/contacts`,
              icon: PhAddressBook,
              show: () => hasPermission('read contacts') || isAdminOrSuperAdmin(),
            },
            {
              name: 'Τα αιτήματά μου',
              href: `/c/${accountId}/contact-requests`,
              icon: PhUsersFour,
              show: () => hasPermission('read contact requests') || isAdminOrSuperAdmin(),
            },
            {
              name: 'Διαχείρηση αιτημάτων',
              href: `/c/${accountId}/pipelines`,
              icon: PhKanban,
              show: () => hasPermission('read pipelines') || isAdminOrSuperAdmin(),
            },
            {
              name: 'Αρχεία',
              href: `/c/${accountId}/assets`,
              icon: MaterialSymbolsLightPermMediaOutline,
              show: () => hasPermission('read assets'),
            },
            {
              name: 'Ημερολόγιο',
              href: `/c/${accountId}/calendar`,
              icon: PhCalendar,
              show: () =>
                hasAllPermissions(['read contact requests', 'read tasks']) || isAdminOrSuperAdmin(),
            },
            {
              name: 'Συναλλαγές',
              href: `/c/${accountId}/marketplace/transactions`,
              icon: PhMoney,
              show: () => hasPermission('read transactions') || isAdminOrSuperAdmin(),
            },
          ],
        },
        {
          name: 'Marketing',
          items: [
            {
              name: 'Email Campaigns',
              to: { name: 'accounts.accountId.emailCampaigns', params: { accountId } },
              icon: PhPaperPlaneTilt,
              show: () => hasPermission('read email campaigns'),
            },
            {
              name: 'Email Templates',
              to: { name: 'accounts.accountId.emailTemplates', params: { accountId } },
              icon: PhEnvelope,
              show: () => hasPermission('read email templates'),
            },
            {
              name: 'SMS Campaigns',
              to: { name: 'accounts.accountId.smsCampaigns', params: { accountId } },
              icon: PhChatsCircle,
              show: () => hasPermission('read sms campaigns'),
            },
          ],
        },
        {
          name: 'Ver 2 (Prev)',
          items: [
            {
              name: 'My projects',
              to: { name: 'accounts.projects', params: { accountId } },
              icon: PhFolder,
              show: () => hasPermission('read projects') || isAdminOrSuperAdmin(),
            },
            {
              name: 'Οι επαφές μου',
              to: { name: 'accounts.accountId.contacts', params: { accountId } },
              icon: PhAddressBook,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Τα αιτήματά μου',
              to: { name: 'accounts.accountId.contactRequests', params: { accountId } },
              icon: PhUsersFour,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Διαχείρηση αιτημάτων',
              to: { name: 'accounts.pipelines', params: { accountId } },
              icon: PhKanban,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Calendar',
              to: { name: 'accounts.calendar', params: { accountId } },
              icon: PhCalendar,
              show: () => isAdminOrSuperAdmin(),
            },
          ],
        },
        {
          items: [
            {
              name: 'Φόρμες',
              href: `/c/${accountId}/forms`,
              icon: PhClipboardText,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Ταξινομήσεις',
              href: `/c/${accountId}/taxonomies`,
              icon: PhTag,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Κουπόνια',
              href: `/c/${accountId}/marketplace/coupons`,
              icon: IconamoonDiscountLight,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Προϊόντα',
              href: `/c/${accountId}/acc-products`,
              exact: true,
              icon: PhCube,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Προσαρμοσμένες ιδιότητες',
              href: `/c/${accountId}/custom-properties`,
              icon: PhTextbox,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Αυτοματισμοί',
              href: `/c/${accountId}/automations`,
              icon: PhRobot,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Ρυθμίσεις marketplace',
              href: `/c/${accountId}/marketplace/settings`,
              icon: PhGear,
              show: () => isAdminOrSuperAdmin(),
            },
            {
              name: 'Onboarding',
              href: `/c/${accountId}/onboarding`,
              icon: PhMagicWand,
              show: () => isAdminOrSuperAdmin(),
            },
          ],
        },
      ];

      return items;
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-full flex-1 bg-gray-900">
    <div class="flex-1 flex flex-col pb-4 overflow-y-auto pt-8">
      <RouterLink
        v-if="$currentAccount.logo"
        :to="{ name: 'accounts.show', params: { accountId: $currentAccount.id } }"
      >
        <img :src="$currentAccount.logo" class="block rounded w-24 mb-8 mx-auto" />
      </RouterLink>
      <h6 class="text-center text-white mb-6">
        {{ $currentAccount.name }}
      </h6>
      <div class="px-6">
        <nav class="flex flex-1 flex-col">
          <ul role="list" class="flex flex-1 flex-col gap-y-7">
            <li v-for="(group, groupIdx) in navigation" :key="groupIdx">
              <div v-if="group.name" class="text-xs font-semibold leading-6 text-gray-400">
                {{ group.name }}
              </div>
              <ul role="list" class="-mx-2 space-y-1">
                <template v-for="item in group.items">
                  <li v-if="(item.show || (() => true))()" :key="item.name">
                    <RouterLink
                      v-if="item.to"
                      :to="item.to"
                      custom
                      v-slot="{ isActive, isExactActive, href, navigate }"
                    >
                      <a
                        :href="href"
                        :class="[
                          (item.exact ? isExactActive : isActive)
                            ? 'bg-gray-800 text-white'
                            : 'text-gray-400 hover:text-white hover:bg-gray-800',
                          'group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                        ]"
                        @click="navigate"
                      >
                        <component
                          v-if="item.icon"
                          :is="item.icon"
                          class="h-6 w-6 shrink-0"
                          aria-hidden="true"
                        />
                        {{ item.name }}
                      </a>
                    </RouterLink>
                    <a
                      v-if="item.href"
                      :href="item.href"
                      :class="[
                        'text-gray-400 hover:text-white hover:bg-gray-800 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold transition-colors',
                      ]"
                    >
                      <component
                        v-if="item.icon"
                        :is="item.icon"
                        class="h-6 w-6 shrink-0"
                        aria-hidden="true"
                      />
                      {{ item.name }}
                    </a>
                  </li>
                </template>
              </ul>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
